import React, { useEffect, useState } from "react";
import { AutoComplete } from "react_reusable_components";

import { RemarkOptions } from "../../constants";
import variables from "../../themes/base/styles/variables";
import Style from "./Remarks.module.scss";

const Remarks = ({
  inputPlaceholder,
  inputValue,
  onInputChange,
  evaluationStatus,
  notFoundPlaceholder,
  disabled,
  getPopupContainer,
}) => {
  const [filteredOptions, setFilteredOptions] = useState(RemarkOptions);

  const handleInputChange = (value) => {
    onInputChange(value);
  };

  const filterOptions = (input) => {
    return filteredOptions.filter((option) =>
      input
        ? option?.label?.toLowerCase().includes(input?.toLowerCase())
        : option?.label
    );
  };

  const renderOptions = () => {
    return filterOptions(inputValue).map((option) => ({
      value: option.label,
      label: (
        <span className={Style["dropdown-item-style"]}>{option?.label}</span>
      ),
    }));
  };

  useEffect(() => {
    if (evaluationStatus) {
      const filterOptionsWithEvaluationStatus = RemarkOptions?.filter(
        (item) => item.associatedValue === evaluationStatus
      );
      setFilteredOptions(filterOptionsWithEvaluationStatus);
      const foundItem = RemarkOptions?.find(
        (item) => item.label === inputValue
      );
      if (foundItem && foundItem?.associatedValue !== evaluationStatus) {
        onInputChange("");
      }
    } else {
      setFilteredOptions(RemarkOptions);
    }
  }, [evaluationStatus]);

  return (
    <AutoComplete
      disabled={disabled}
      style={{ width: variables.fullWidth }}
      value={inputValue}
      onChange={handleInputChange}
      options={renderOptions()}
      placeholder={
        <span className={Style["placeholder-style"]}>{inputPlaceholder}</span>
      }
      notFoundContent={false}
      getPopupContainer={getPopupContainer}
    />
  );
};

export default Remarks;
